import React, {useState} from "react";
import {ScreenId, Svgs} from "@assets";
import styles from "./style.module.scss";
import {useLogin, useNav} from "@hook";
import {Modal} from "@adminComponents";
import {useRecoilValue} from "recoil";
import {states} from "@recoils";

export default function Component() {
  const {userData, logout} = useLogin();
  const {navigate} = useNav();
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const infoData = useRecoilValue(states.infoDataState);
  const noticeData = (infoData || []).find(item => item.type === "home");

  function goToMenu(url: ScreenId) {
    setIsSideMenuOpen(false);

    if (
      [ScreenId.HOME, ScreenId.LOGIN, ScreenId.KAKAO_LOGIN_CALLBACK].includes(
        url,
      )
    ) {
      return navigate({url: url});
    }
    if (!userData) {
      return navigate({url: ScreenId.LOGIN});
    }
    if (userData.confirm !== "1") {
      return alert(
        "현재 계정은 승인 대기 상태입니다.\n관리자 승인 완료까지 잠시만 기다려 주세요.",
      );
    }
    navigate({url: url});
  }

  return (
    <>
      <div className={styles.container}>
        {!!noticeData && (
          <div
            className={styles.notice}
            onClick={() =>
              noticeData.content
                ? window.open(noticeData.content, "_blank")
                : undefined
            }>
            <span>NOTICE</span>
            <span>{noticeData.title}</span>
          </div>
        )}
        <div className={styles.menuContainer}>
          <div className={styles.logo} onClick={() => goToMenu(ScreenId.HOME)}>
            <Svgs.Logo fill="#221E1F" />
          </div>
          <div className={styles.menu}>
            <div
              className={styles.menuItem}
              onClick={() => goToMenu(ScreenId.ABOUT)}>
              회장 인사말
            </div>
            <div
              className={styles.menuItem}
              onClick={() => goToMenu(ScreenId.ORGANIC)}>
              조직도
            </div>
            <div
              className={styles.menuItem}
              onClick={() => goToMenu(ScreenId.MEMBER)}>
              회원현황
            </div>
            <div
              className={styles.menuItem}
              onClick={() => goToMenu(ScreenId.NOTICE)}>
              공지사항
            </div>
          </div>
          <div
            className={styles.login}
            onClick={() => {
              if (userData) {
                logout();
                goToMenu(ScreenId.HOME);
              } else {
                goToMenu(ScreenId.LOGIN);
              }
            }}>
            {userData ? "로그아웃" : "로그인"}
          </div>
          <div
            className={styles.toggleMenu}
            onClick={() => setIsSideMenuOpen(true)}>
            <Svgs.Menu width={20} />
          </div>
        </div>
      </div>
      <SideMenu
        visible={isSideMenuOpen}
        close={() => setIsSideMenuOpen(false)}
        goToMenu={goToMenu}
      />
    </>
  );
}

function SideMenu({
  visible,
  close,
  goToMenu,
}: {
  visible: boolean;
  close?: () => void;
  goToMenu: (url: ScreenId) => void;
}) {
  const {token, logout} = useLogin();

  return (
    <Modal
      visible={visible}
      close={close}
      toWay="right"
      position={{left: 0, bottom: 0, right: 0, top: 40}}
      className={styles.modalContainer}>
      <div className={styles.modal}>
        <div className={styles.titleRow}>
          <div className={styles.logo} onClick={() => goToMenu(ScreenId.HOME)}>
            <Svgs.Logo fill="black" />
          </div>
          <div className={styles.close} onClick={close}>
            <Svgs.Close />
          </div>
        </div>
        <div className={styles.menu}>
          <div
            className={styles.menuItem}
            onClick={() => goToMenu(ScreenId.ABOUT)}>
            회장 인사말
          </div>
          <div
            className={styles.menuItem}
            onClick={() => goToMenu(ScreenId.ORGANIC)}>
            조직도
          </div>
          <div
            className={styles.menuItem}
            onClick={() => goToMenu(ScreenId.MEMBER)}>
            회원현황
          </div>
          <div
            className={styles.menuItem}
            onClick={() => goToMenu(ScreenId.NOTICE)}>
            공지사항
          </div>
          <div
            className={[styles.menuItem, styles.login].join(" ")}
            onClick={() => {
              if (token) {
                logout();
                goToMenu(ScreenId.HOME);
              } else {
                goToMenu(ScreenId.LOGIN);
              }
            }}>
            {token ? "로그아웃" : "로그인"}
          </div>
        </div>
      </div>
    </Modal>
  );
}
